/* MARMOT: home – логика на хирото (Редизайн Фаза А2, Порция 1).
   Vanilla JS, зарежда се с defer. Две ротации:
   - думата в H1: ~2,2 сек, спира на последната;
   - слайдовете (корица + подложки заедно): ~3,4 сек, безкрайно.
   При prefers-reduced-motion не се стартира нищо (CSS показва слайд 1). */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initHero(root) {
    if (root.dataset.marmotInit === '1') return;
    root.dataset.marmotInit = '1';
    if (REDUCED.matches) return;

    initWordRotation(root);
    initSlides(root);
  }

  function initWordRotation(root) {
    var wordEl = root.querySelector('[data-marmot-word]');
    var dataEl = root.querySelector('[data-marmot-words]');
    if (!wordEl || !dataEl) return;

    var words;
    try {
      words = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(words) || words.length < 2) return;

    var interval = parseInt(root.dataset.wordInterval, 10) || 2200;
    var idx = 0;

    var timer = setInterval(function () {
      idx += 1;
      wordEl.classList.add('is-out');
      setTimeout(function () {
        wordEl.textContent = words[idx];
        wordEl.classList.remove('is-out');
      }, 280);
      // Спира на последната дума.
      if (idx >= words.length - 1) clearInterval(timer);
    }, interval);
  }

  function initSlides(root) {
    var slides = root.querySelectorAll('[data-marmot-slide]');
    var dots = root.querySelectorAll('[data-marmot-dot]');
    if (slides.length < 2) return;

    var interval = parseInt(root.dataset.slideInterval, 10) || 3400;
    var current = 0;
    var timer = null;

    function show(next) {
      if (next === current) return;
      slides[current].classList.remove('is-active', 'is-entering');
      slides[next].classList.add('is-active', 'is-entering');
      if (dots.length) {
        dots[current].classList.remove('is-active');
        dots[next].classList.add('is-active');
      }
      current = next;
    }

    function start() {
      stop();
      timer = setInterval(function () {
        show((current + 1) % slides.length);
      }, interval);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        start(); // рестартира отброяването след ръчен избор
      });
    });

    // Пауза, когато табът е скрит – пести батерия и пази INP.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  function initAll() {
    document.querySelectorAll('[data-marmot-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: секцията се пре-рендерира при промяна на настройки.
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target.querySelector('[data-marmot-hero]');
    if (hero) initHero(hero);
  });
})();
